import React, { useState } from 'react'
import { Button, Input, InputGroup, Spinner } from 'reactstrap'

interface ChatInputProps {
  isLoading: boolean
  messageCount: number
  onSend: (text: string) => void
  onNewConversation: () => void
}

const ChatInput: React.FC<ChatInputProps> = ({
  isLoading,
  messageCount,
  onSend,
  onNewConversation,
}) => {
  const [inputValue, setInputValue] = useState('')

  const trimmedValue = inputValue.trim()
  const isSendDisabled =
    isLoading || trimmedValue.length === 0 || inputValue.length > 2000

  const handleSend = () => {
    if (!isSendDisabled) {
      onSend(trimmedValue)
      setInputValue('')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const showCharacterCounter = inputValue.length > 1800

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <InputGroup>
        <Input
          type="text"
          placeholder="Ask a question..."
          value={inputValue}
          onChange={(e) => setInputValue(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        {showCharacterCounter && (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingRight: '8px',
              paddingLeft: '8px',
              color: inputValue.length > 1900 ? '#dc3545' : '#6c757d',
              fontSize: '0.875rem',
            }}
          >
            {inputValue.length} / 2000
          </span>
        )}
        <Button
          color="primary"
          onClick={handleSend}
          disabled={isSendDisabled}
          style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
        >
          {isLoading ? <Spinner size="sm" color="light" /> : 'Send'}
        </Button>
      </InputGroup>

      {messageCount > 0 && (
        <Button
          color="secondary"
          outline
          size="sm"
          onClick={onNewConversation}
          style={{ alignSelf: 'flex-start' }}
        >
          New conversation
        </Button>
      )}
    </div>
  )
}

export default ChatInput
